import * as amplitude from "@amplitude/unified";

const AMPLITUDE_API_KEY = "91332ff552a55b4bc9e878636e2b2f97";

// 17050366225 - Conversion Id
// Conversaion Label
// Signup (Ads)
// qhbzCKT474MbEJHin8I_

export const initAmplitude = async ({ pageViews = true }) => {
    // Check if running on localhost
    const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "0.0.0.0";

    // Don't track if on localhost
    if (isLocalhost) {
        console.log("Analytics: Skipping tracking on localhost");
        return amplitude;
    }

    // Initialize amplitude after adding plugins
    amplitude.initAll(AMPLITUDE_API_KEY, {
        defaultTracking: true,
        autocapture: {
            pageViews: pageViews,
            defaultTracking: true,
        },
        fetchRemoteConfig: true,
        autocapture: true,
        sessionReplay: {
            // Session Replay configuration options
            sampleRate: 1, // To enable session replay
        },
    });

    return amplitude;
};

export const initGoogleAnalytics = () => {};

export const track = (event, properties) => {
    // Check if running on localhost
    const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "0.0.0.0";

    // Don't track if on localhost
    if (isLocalhost) {
        console.log(`Analytics: Skipping track event "${event}" on localhost`);
        return;
    }

    amplitude.track(event, properties);
};

export const trackGoogleAnalytics = (eventName, parameters = {}) => {};
export const trackGoogleAnalyticsPurchase = (
    transactionId,
    value,
    currency = "USD",
    priceId,
    priceName
) => {
    // Purchase event tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "purchase",
        ecommerce: {
            transaction_id: transactionId, // string
            value: Number(value),
            currency: currency, // e.g. 'USD'
            items: [
                {
                    item_id: priceId, // fix: was proceId
                    item_name: priceName,
                    price: Number(value),
                    quantity: 1,
                },
            ],
        },
    });
};
export const trackSignup = (email) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "sign_up",
        email: email,
    });
};

export const setUserId = (userId) => {
    // Check if running on localhost
    const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "0.0.0.0";

    // Don't track if on localhost
    if (isLocalhost) {
        console.log(`Analytics: Skipping setUserId "${userId}" on localhost`);
        return;
    }

    amplitude.setUserId(userId);
};
